import React from 'react';

import { PaymentSearchForm } from './PaymentSearchForm/PaymentSearchForm';
import { PaymentSearchResults } from './PaymentSearchResults/PaymentSearchResults';

import { PaymentSearchState } from './PaymentSearch.state';
import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/AppState/Common';

export const PaymentSearchV2 = observer('PaymentSearch', () => {
    const appState = useAppStateContext();
    const common = useCommon();

    const [state] = React.useState(() => new PaymentSearchState(common, appState.common.trpcClient));

    return state.results !== undefined && state.results.results.length > 0 ? (
        <PaymentSearchResults
            results={state.results}
            requestQuery={state.requestQuery}
            getResults={state.getResults}
            clearResults={state.clearResults}
        />
    ) : (
        <PaymentSearchForm
            getResults={state.getResults}
            fromDate={state.fromDate}
            account={state.account}
            fromAmount={state.fromAmount}
            isChecked={state.isChecked}
            onCheckChange={state.onCheckChange}
            onSubmit={state.onSubmit}
            toAmount={state.toAmount}
            toDate={state.toDate}
            includeSummary={state.includeSummary}
            saveReport={state.saveReport}
            transactionType={state.transactionType}
        />
    );
});
